import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button } from 'reactstrap';
import { mind_pattern_sections } from '../../../core/constants';
import { Disclaimers } from '../common';
import { pdfsActions } from '../../../core/pdfs';
import LoadingIndicator from '../loading-indicator';
import { ModalSubmitAssessment, ModalLockedAssessment } from '../common/assessments-modals';
import { StepProgress } from './step-progress';
import ReportActions from './report-actions';


const Report = (props) => {
    const { attentionTypes, areas, hanndleNext, reports, selected_options, mind_pattern, mind_pattern_unsaved, setRetake, viewMode, handleSaveMindPattern } = props;
    const dispatch = useDispatch();
    const pdf = useSelector(state => state.pdf);
    const user = useSelector(state => state.user );
    const [ openModalConfirm, setOpenModalConfirm ] = useState(false);
    const [ openModalLock, setOpenModalLock ] = useState(false);

    const eventGA = () => {
        setRetake(true)
    }

    const mindPatternsAreas = areas;
    const getDataArea = useMemo(() => (code) => {
        if (!mindPatternsAreas?.items?.size) return null;

        const area = mindPatternsAreas.items.find(mpArea => { return mpArea.code.toLowerCase() === code.toLowerCase() });
        return area;
    }, [mindPatternsAreas]);

    const currentStepProgress = useMemo(() => {
        if(!mind_pattern) {
            return 1;
        }
        if(mind_pattern_unsaved) {
            return 2;
        }
        return 4;
    }, [mind_pattern, mind_pattern_unsaved])

    const code = mind_pattern ? mind_pattern : selected_options.toJS().join("");
    const report = reports.find(item => item.code === code);

    if (!report) {
        return (<><h3> report not found </h3></>)
    } else {
    }

    const list_report = reports.map(item => {
        if (item.code === code)
            return null;

        const mind_patterns = item.code.split("").map((mp, k) => {
        const area = getDataArea(mp);

        return (
        <div key={item.id + '_' + mp} className={`rounded-circle mind-pattern-area mind-pattern-area-sm bg-${area?.name.toLowerCase()} ${area?.name.toLowerCase() !== 'auditory' ? 'text-white' : ''}`}>{mp}</div>
        )}
    )

        return <div key={item.id} className="cursor-pointer rounded border p-2 d-flex align-items-center justify-content-between flex-fill" onClick={() => hanndleNext(mind_pattern_sections.REPORT_COMPLETE, item.id)}>
            <div className='d-flex gap-10 mr-3'>{mind_patterns}</div>
            <i className="bi bi-chevron-right">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
            <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
            </svg>
            </i>
        </div>
    })

    const mind_patterns = report.code.split("").map((mp, k) => {
        const area = getDataArea(mp);

        return (
        <div key={mp + k} className={`text-md-left p-md-3 p-2 border rounded border-${area?.name.toLowerCase()}`}>
            <div className='d-flex flex-column flex-md-row justify-content-between align-items-center'>
                <i className='mb-3'><img src={area?.icon} alt={area?.name} width="64" height="64" /></i>
                <div className={`mb-3 rounded-circle mind-pattern-area bg-${area?.name.toLowerCase()} ${area?.name.toLowerCase() !== "auditory" ? 'text-white' : ''}`}>{mp}</div>
            </div>
            <p className="mb-0 h4-sm h5 text-capitalize">{area?.name}</p>
            <p className="h5-md h6 mb-0 text-muted font-weight-normal">{attentionTypes[k]}</p>
        </div>
        )
    })

    const getFullReportMP = () => {
        dispatch(pdfsActions.loadFullReportMP())
    }

    const handleConfirmSave = () => {
        // if(!user?.assessments_block_days) {
        //     handleSaveMindPattern(mind_pattern);
        //     return;
        // }
        setOpenModalConfirm(true);
    }

    const handleRetake = () => {
        if(!user?.has_mp_blocked) {
            hanndleNext(mind_pattern_sections.START); 
            eventGA();
            return;
        }
        setOpenModalLock(true);
    }

    return (
        <div className='position-relative mp-report'>
            <div className='mb-3 pt-md-4'>
                <div className='w-100 d-flex justify-content-center'>
                    <StepProgress currentStep={currentStepProgress} />
                </div>

                <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Mind Patterns</h1>
                {mind_pattern_unsaved && 
                    <>
                        <p><strong>Review your results</strong></p>
                        <p>Please look over your Mind Pattern. You can either submit your answers or retake the assessment from here. You can also select one of the other Mind Patterns options below to read more about these and select them instead before submitting.</p>
                    </>
                }
                <p className="mb-0">Your Mind Pattern is the unique way in which you process and respond to information. Mind Patterns can also help you intentionally shift from focused to generative thinking and help you design a working environment and develop new habits that evoke your best thinking. When working with others, understanding our Mind Pattern can help us dissolve some of the immediate ways we misread and therefore misjudge or miscommunicate with others.</p>
            </div>

            <Row>
                <Col xl={{ size: 7 }} className='mx-auto'>
                    <div className='pt-md-3 px-md-3 px-2 pt-2 border rounded text-center mb-3'>
                        <h2 className='h3-md h4 mb-3'>Your mind pattern</h2>
                        <div className='mind-pattern-report-user mb-2'>{mind_patterns}</div>
                        {!viewMode &&
                        <>
                            <Button onClick={() => hanndleNext(mind_pattern_sections.REPORT_COMPLETE, report.id)} color="link" className="mb-4 text-nowrap d-inline p-0 text-danger font-weight-semibold">
                                View more
                                <i className='ml-2'>
                                <svg xmlns="http://www.w3.org/2000/svg" height="12" width="6" fill="currentColor" viewBox="0 0 6 12">
                                    <path d="M5.6,6.5l-4.4,4.4C1.1,11,0.9,11,0.7,11S0.4,11,0.3,10.8c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5L4.2,6
                                    L0.3,2.1C0.2,2,0.2,2,0.1,1.9c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2C0.3,1.1,0.4,1,0.5,1
                                    C0.6,1,0.7,1,0.8,1C0.8,1,0.9,1,1,1c0.1,0,0.2,0.1,0.2,0.1l4.4,4.4c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2-0.1,0.3
                                    C5.7,6.3,5.7,6.4,5.6,6.5z"/>
                                </svg>
                                </i>
                            </Button>

                        </>
                        }
                    </div>
                </Col>
            </Row>

            {!viewMode &&
                <>
                    <div className='p-md-3 border-md rounded'>
                        <h2 className="h3-md h4 mb-3">The other mind patterns</h2>
                        <p className='mb-3'><strong>Set mind pattern manually</strong> If you think that this summary does not accurately represent you, you have the option to set your Mind Pattern manually You will find the button to change your Mind Pattern at the bottom of each one of these reports:</p>
                        <div className='d-flex flex-column flex-md-row justify-content-between flex-wrap gap-15'>{list_report}</div>
                    </div>
                </>
            }
            <Disclaimers view="copyright" />

            <ReportActions
                mind_pattern_unsaved={mind_pattern_unsaved}
                user={user}
                handleConfirmSave={handleConfirmSave}
                getFullReportMP={getFullReportMP}
                handleRetake={handleRetake}
            />


            {pdf.isPending && <LoadingIndicator />}

            <ModalSubmitAssessment 
                isOpen={openModalConfirm} 
                close={() => setOpenModalConfirm(false) } 
                onAccept={() => { 
                    handleSaveMindPattern(mind_pattern);
                    setOpenModalConfirm(false);
                }} 
                onCancel={() => setOpenModalConfirm(false) }
                blockDays={user?.assessments_block_days}
                showMessage={user?.assessments_block_days && mind_pattern_unsaved}
            />
            
            <ModalLockedAssessment 
                isOpen={openModalLock} 
                close={() => setOpenModalLock(false) } 
                blockDays={user?.assessments_block_days}
            />
        </div>
    )

}

export default Report;
